import _ from 'lodash'
import { setTimeout } from 'core-js'
import Vue from 'vue'

export default {
	namespaced: true,
	state: {
		passport: {
			identities: []
		},
		interactions: {
			web: {
				details: true,
				completed: false,
				events: []
			},
			ads: {
				completed: false,
				details: true,
				events: []
			},
			call: {
				completed: false,
				details: true,
				events: []
			},
			forms: {
				completed: false,
				details: true,
				events: []
			},
			notification: {
				completed: false,
				details: true,
				events: []
			},
			email: {
				completed: false,
				details: true,
				events: []
			},
			meetings: {
				completed: false,
				details: true,
				events: []
			},
			passport: {
				completed: false,
				details: true
			},
			crm: {
				completed: false,
				events: []
			}
		}
	},
	getters: {
		interactionsTotal: state => _.keys(state.interactions).length,
		interactionsCompleted: state => _.keys(state.interactions).filter(interaction => state.interactions[interaction].completed).length,
	},
	mutations: {
		updatePassport(state, passport) {
			state.passport = passport
			if (passport && passport.brief) {
				state.interactions.passport.completed = true
			}
		},
		denouncePassport(state) {
			// console.log('Passport forgotten')
			state.passport = {}
			for(let key in state.interactions) {
				let interaction = state.interactions[key]
				interaction.completed = false
				if (interaction.details != undefined) interaction.details = true
				if (interaction.events) {
					interaction.events.length = 0
				}
			}
		},
		updateInteractions(state, events) {
			Vue.$forceNextTick(() => {
				state.interactions.web.events = events.filter(event => event.action.application == 'analytics').reverse()
				if (state.interactions.web.events.length) {
					state.interactions.web.completed = true
				} else {
					state.interactions.web.completed = false
				}
			})

			Vue.$forceNextTick(() => {
				state.interactions.call.events = events.filter(event => event.action.application == 'voip').reverse()
				if (state.interactions.call.events.length) {
					state.interactions.call.completed = true
				} else {
					state.interactions.call.completed = false
				}
			})

			Vue.$forceNextTick(() => {
				state.interactions.email.events = events.filter(event => event.action.application == 'mail' && event.action.context != 'apply' ||
					event.action.type == 'analytics.view' && event.details['url.href'].indexOf('utm_medium=mail') != -1
				).reverse()
				
				if (state.interactions.email.events.filter(event => event.action.type == 'mail.send' || 
					event.attribution.medium == 'mail' && event.attribution.campaign == 'demo').length
				) {
					state.interactions.email.completed = true
				} else {
					state.interactions.email.completed = false
				}

				if (events.filter(event => event.attribution.medium == 'mail' && event.attribution.campaign == 'demo').length) {
					state.interactions.email.details = false
				} else {
					state.interactions.email.details = true
				}
			})

			Vue.$forceNextTick(() => {
				state.interactions.notification.events = events.filter(
					event => event.action.application == 'sms' || 
					event.action.application == 'shortener' && event.attribution.campaign == 'demo' || 
					event.action.application == 'mail' && event.action.context == 'apply' && event.details && event.details.context == 'demo-notification' ||
					event.action.type == 'analytics.view' && event.details['url.href'].indexOf('utm_medium=sms') != -1
				).reverse()
				if (state.interactions.notification.events.filter(event => event.action.application == 'sms').length) {
					state.interactions.notification.details = false
				} else {
					state.interactions.notification.details = true
				}
				if (state.interactions.notification.events.filter(event => event.action.application == 'shortener' ||
					event.attribution.medium == 'sms' && event.attribution.campaign == 'demo').length) {
					state.interactions.notification.completed = true
				} else {
					state.interactions.notification.completed = false
				}
			})

			Vue.$forceNextTick(() => {
				state.interactions.forms.events = events.filter(
					event => event.action.application == 'mail' && event.action.context == 'apply' && event.details && event.details.context == 'demo-forms'
				).reverse()
				if (state.interactions.forms.events.length) {
					state.interactions.forms.details = false
					state.interactions.forms.completed = true
				} else {
					state.interactions.forms.details = true
					state.interactions.forms.completed = false
				}
			})

			Vue.$forceNextTick(() => {
				state.interactions.meetings.events = events.filter(
					event => event.action.application == 'mail' && event.action.context == 'send' && event.details.context == 'demo-meetings' ||
					event.action.application == 'data' && event.action.context == 'event'
				).reverse()
				if (state.interactions.meetings.events.length) {
					state.interactions.meetings.completed = true
				} else {
					state.interactions.meetings.completed = false
				}
				if (events.filter(event => event.action.application == 'data' && event.action.context == 'event').length) {
					state.interactions.meetings.details = false
				} else {
					state.interactions.meetings.details = true
				}
			})

			Vue.$forceNextTick(() => {
				if (events.filter(event => event.action.application == 'data' && event.action.context == 'event').length) {
					state.interactions.crm.completed = true
				} else {
					state.interactions.crm.completed = false
				}
			})

			Vue.$forceNextTick(() => {
				if (events.filter(event => event.attribution.medium == 'site').length) {
					state.interactions.ads.completed = true
				} else {
					state.interactions.ads.completed = false
				}
			})

		},
	},
	actions: {
		forget({commit}) {
			window.whitebox.services.passports.forget()
			commit('denouncePassport')
		},
		init({commit, dispatch}) {
			let refresh
			window.whitebox.init('passports', passports => {
				if (passports) {
					commit('updatePassport', passports.service.passport)
					passports.on('passports.passport', passport => {
						clearTimeout(refresh)
						if(passport) {
							commit('updatePassport', passport)
						}
					}, this)
					passports.on('passports.denounce', function() {
						refresh = setTimeout(() => commit('denouncePassport'), 3000)
					})
				}
			})
			window.whitebox.init('reports', reports => {
				if (reports) {
					dispatch('reloadSettings', reports.service.settings, { root: true })
					commit('updateInteractions', reports.service.events)
					dispatch('aida/funnel', reports.service.events, {root:true})
					reports.on('reports.events', events => {
						commit('updateInteractions', events)
						dispatch('aida/funnel', reports.service.events, {root:true})
					})
				}
			})
		}
	},
}
